import * as React from 'react';
import * as classnames from 'classnames/bind';
import _get from 'lodash/get';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import {
    IWidgetComponentProps,
    TextInputWidget,
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/FlowPropertiesWidgets';
import {ImgIcon} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcon';
import {ImgIcons} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcons';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/PasswordWidget.less');
const cx = classnames.bind(styles);

interface IPasswordWidgetState
{
    isVisible:boolean;
}

@observer
export class PasswordWidget extends React.Component<IWidgetComponentProps, any>
{
    @observable
    private _state:IPasswordWidgetState = {
        isVisible: false,
    };

    render()
    {
        const {isVisible} = this._state;

        return (
            <TextInputWidget
                {...this.props}
                inputProps={{
                    className: styles.input,
                    htmlType: isVisible ? 'text' : 'password',
                    noSavePassword: true,
                    autoComplete: 'new-password',
                }}
            >
                <div
                    className={cx('eyeIconWrapper', {isToggled: !isVisible})}
                    onMouseDown={this._handleEyeMouseDown}
                >
                    <ImgIcon icon={ImgIcons.eye} className={styles.eyeIcon} />
                    <ImgIcon icon={ImgIcons.eyeActive} className={styles.eyeIconActive} />
                    <ImgIcon icon={ImgIcons.cross} className={styles.crossIcon} />
                </div>
            </TextInputWidget>
        );
    }

    @action
    private _handleEyeMouseDown = (event:React.SyntheticEvent<HTMLElement>) =>
    {
        this._state.isVisible = !this._state.isVisible;
    };
}
